import { useQuery } from '@tanstack/react-query'
import {
  countMyTurnCodReductions,
  fetchCodReductionStatusesCreated,
  fetchCompletedCodReductions,
  fetchNeedAdjustCodReductions,
  listCodReductions,
  sumCodReductions,
} from './cod-reductions-list-repository'
import { buildCodReductionReport, countByStatus } from './cod-reduction-report'
import { isMissingRelation } from './use-cod-reductions'
import type { CodReductionListFilter } from '@/types/db'

const LIST_KEY = ['cod-reductions-list'] as const

export function useCodReductionList(filter: CodReductionListFilter) {
  return useQuery({ queryKey: [...LIST_KEY, filter] as const, queryFn: () => listCodReductions(filter) })
}

export function useCodReductionSum(filter: CodReductionListFilter) {
  // Bỏ page/pageSize khỏi key: tổng không phụ thuộc phân trang.
  const key = { ...filter, page: undefined, pageSize: undefined }
  return useQuery({ queryKey: [...LIST_KEY, 'sum', key] as const, queryFn: () => sumCodReductions(filter) })
}

// Badge "Chờ tôi duyệt" (tab + sidebar). FAIL-SOFT: lỗi (DB chưa chạy migration, mất
// mạng…) → 0, không retry, không toast — sidebar hiện trên MỌI trang.
export function useCodReductionMyTurnCount(enabled = true) {
  return useQuery({
    queryKey: [...LIST_KEY, 'my-turn-count'] as const,
    queryFn: async () => {
      try {
        return await countMyTurnCodReductions()
      } catch (e) {
        if (!isMissingRelation(e)) console.warn('[cod-reduction] đếm chờ duyệt lỗi:', e)
        return 0
      }
    },
    enabled,
    retry: false,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  })
}

export function useCodReductionReport(range: { from: string | null; to: string | null }) {
  return useQuery({
    queryKey: [...LIST_KEY, 'report', range] as const,
    queryFn: async () => {
      const [completed, created, needAdjust] = await Promise.all([
        fetchCompletedCodReductions(range),
        fetchCodReductionStatusesCreated(range),
        fetchNeedAdjustCodReductions(range),
      ])
      return {
        rows: completed,
        report: buildCodReductionReport(completed),
        createdStatus: countByStatus(created),
        needAdjust,
      }
    },
  })
}
